var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackRightLeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 76,
    viewBox: "0 0 19 76",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3612 0.850586C10.4274 4.4566 3.21533 5.11224 1.24841 2.81751C-0.16303 32.3213 2.23187 51.007 2.88751 56.9078C3.41202 61.6284 2.22278 66.5238 1.67639 67.7258C0.400179 71.0041 0.0722291 72.3153 1.67639 73.6266C3.15462 74.8349 11.7295 75.0472 16.4283 74.6101C18.4302 74.4238 19.0858 73.6266 18.0674 72.3153C14.6581 70.2173 13.5129 71.0041 11.8738 67.7258C10.8903 66.0867 10.9253 57.2356 11.8738 53.9574C18.1373 39.2055 14.3612 10.3574 14.3612 0.850586Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackRightLeg);
export default __webpack_public_path__ + "static/media/BackRightLeg.9723831301a66b3ecd336afe52593b16.svg";
export { ForwardRef as ReactComponent };